import type { FC } from 'react';
import styled from 'styled-components';

import { useMapData } from '../../map-data/use-map-data';
import type { PointOfInterestRecord } from '../../map-types';
import { CodeBadge } from '../CodeBadge';
import { getRgb } from '../PinMap/get-rgb';
import { theme } from '../../styles/theme';

export interface PoiResultItemComponentProps {
  hit: {
    objectID: string;
  };
  onResultClick?: (record: PointOfInterestRecord) => void;
}

const ResultWrapper = styled.div`
  cursor: pointer;
  padding: ${theme.spacing(4)};
  width: 100%;
`;

export const PoiResultItem: FC<PoiResultItemComponentProps> = ({
  hit,
  onResultClick,
}) => {
  const { loading, studiesById } = useMapData();

  const record = studiesById?.[hit.objectID];

  if (loading || !record) {
    return null;
  }

  const entryTypeColor = getRgb(record.design, true);

  return (
    <ResultWrapper
      onClick={() => onResultClick?.({ ...record, id: hit.objectID })}
    >
      <span
        style={{
          transform: 'translateY(-1px)',
          display: 'inline-block',
          marginRight: theme.spacing(1),
        }}
      >
        <CodeBadge code={hit.objectID} backgroundColor={entryTypeColor} />
      </span>{' '}
      {record.studyAcronym && `${record.studyAcronym} - `}
      {record.studyName}
    </ResultWrapper>
  );
};
